<template>
  <div class="NewsDetails">
    <banner img="n_bg.jpg" :title="newsIdList.Type==1?'公司新闻':'行业动态'"/>
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <img v-for="item in newsIdList.Img" :key ="item" v-lazy="require('../assets/news/'+item)" alt="新闻插图" />
        <div class="product-box">
          <p class="product-title">{{newsIdList.Title}}</p>
          <p class="product-time">{{newsIdList.CreateTime}}</p>
          <p class="product-content">{{newsIdList.Content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      // newsIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    // this.loadData();
  },
  computed:{
    newsIdList(){
      return this.$store.state.newsCompany.filter(v=>v.Id==this.pid)[0]
    }
  },
  methods: {
    // loadData() {
    //   this.$http
    //     .get(`News/GetNewsById/${this.pid}`)
    //     .then(response => {
    //       //console.log(response);
    //       this.newsIdList = response.data;
    //       window.console.log(this.newsIdList);
    //     })
    //     .catch(function(error) {
    //       window.console.log(error);
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    max-width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    // border: 1px solid red;
    &-content {
      max-width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 20px;
      img {
        width: 100%;
        padding-bottom: 20px;
        //height: 500px;
      }
      .product-box{
        .product-title {
          font-size: 25px;
          color: #e13834;
          padding: 20px 0;
        }
        .product-content {
          font-size: 17px;
          font-weight: bolder;
          padding: 20px 0;
          text-indent:2em;
          white-space:pre-wrap;
          line-height: 28px;

        }
      }
      
    }
  }
}
</style>